import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AssignRoleLayer from "../components/AssignRoleLayer";
import CallLogsLayer from "../components/CallLogsLayer";


const CallLogsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Call Logs" />

        {/* AssignRoleLayer */}
        <CallLogsLayer />


      </MasterLayout>
    </>
  );
};

export default CallLogsPage;
